export default () => ({
  token: "",
  userInfo: {},
  userId: "",
  userInfoLoading: false,
  avatarUrl: "", // 用户头像URL
  is_dev: false, // 是否是开发环境
});
